import { Link } from 'react-router-dom';

import { cn } from 'support/helpers/cn/cn';

type CardProps = {
  value: number;
  title: string;
  to: string;
  className?: string;
};

export const Card = ({ value, title, to, className }: CardProps) => {
  return (
    <Link
      to={to}
      className={cn(
        'flex flex-col gap-1 rounded-2xl bg-white p-6 outline-1 -outline-offset-1 outline-gray-200 transition-all outline-solid hover:bg-gray-100 hover:shadow-md focus:outline-2 focus:outline-offset-0 focus:outline-procuros-green-400',
        className,
      )}
    >
      <span className="text-xs text-gray-500">{title}</span>
      <span className="text-2xl leading-8 font-extrabold text-gray-900">{value}</span>
    </Link>
  );
};
